import { useMemo } from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";

const RHFSelectWithInvalid = ({name,label,methods,refinedOptions,masterOptions,placeholder = '--Select--',disableNote = '(No Longer Available)',style,showWarningMessage = false}) => {
    // const {control} = useFormContext();
    const {control} = methods;

    const currentValue = useWatch({control,name});

    const{eligibleOptions,invalidCurrentOption,isCurrentInvalid} = useMemo(() => {
        const byId = (list) => {
            const map = new Map();
            list?.forEach(o => {if (o && o.id !== null) map.set(String(o.id),o);});
            return map;
        };

        const refinedMap = byId(refinedOptions || []);
        const masterMap = byId(masterOptions || []);

        const eligibleOptions = (refinedOptions || []).map(o => ({
            id: String(o.id),
            label: String(o.name)
        }));

        const cvKey = currentValue !== null ? String(currentValue) : null;

        let invalidCurrentOption = null;
        let isCurrentInvalid = false;

        if(cvKey && !refinedMap.has(cvKey)){
            //Current value is not eligible try to find in master list
            const inMaster = masterMap.get(cvKey);

            if(inMaster){
                invalidCurrentOption = {
                    id: cvKey,
                    labelWithNote: `${inMaster.name} ${disableNote}`
                };
                isCurrentInvalid = true;
            }
            else{
                invalidCurrentOption = {
                    id: cvKey,
                    labelWithNote: `Unknown` //Shouldn't occur
                };
                isCurrentInvalid = true;
            }

        }

        return {eligibleOptions,invalidCurrentOption,isCurrentInvalid};
    },[currentValue,refinedOptions,masterOptions,disableNote])


    return(
        <Controller 
            control={control}
            name={name}
            render={({field}) => (
                <>
                    {label && (
                        <label htmlFor={name}>{label}</label>
                    )}
                    <select id={name} {...field} value={field.value ?? ''} style={{...style,color: invalidCurrentOption ? 'red' : 'black'}}>
                        <option style={{color: 'black'}} value=''>{placeholder}</option>
                        {invalidCurrentOption && (
                            <option value={invalidCurrentOption.id} disabled style={{color: 'red'}}>{invalidCurrentOption.labelWithNote}</option>
                        )}
                        {eligibleOptions.map(opt => (
                            <option key={opt.id} value={opt.id} style={{color: 'black'}}>{opt.label}</option>
                        ))}
                    </select>
                    {isCurrentInvalid && showWarningMessage && (field.value ?? '') !== '' && (
                        <small style={{color: 'red',display: 'block'}}>The selected option is no longer valid. You can keep it (for now) or choose a new eligible option.</small>
                    )}
                </>
            )}
        />
    )
}

export default RHFSelectWithInvalid;